import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Product, productType } from '../../types/slices/productType'

const initialState: productType =
{
    status: ApiStatus.FETCHED,
    products: [],
    totalRows: 0,
    productSelected: {} as Product,
    errorMessage: undefined,
    action: ''
}

const productSlice = createSlice({
    name: 'productSlice',
    initialState,
    reducers: {
        onFetchProducts (state, { payload }: { payload: Product[]}) {
            state.status = ApiStatus.FETCHED
            state.products = payload
            state.errorMessage = undefined
        },
        onSetSelectedProduct (state, { payload }: { payload: Product }) {
            state.productSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
        setTotalRows (state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
    }
})

export const selectProductState = (state: RootState) => state.productSlice
export default productSlice.reducer
export const {
    onFetchProducts,
    onSetSelectedProduct,
    changeStatus,
    setAction,
    setTotalRows
} = productSlice.actions
